import { Component, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';
import { MessengerService } from '@services/messenger/messenger.service';
import { OpenReadmeService } from '@services/readme/open-readme.service';
import { ReadmeService } from '@services/readme/readme.service';

declare const require;

@Component({
    selector: 'readme',
    templateUrl: './readme.component.html',
    styleUrls: ['./readme.component.scss'],
    providers: [ReadmeService],
    standalone: false
})
export class ReadmeComponent implements OnInit {

  public mappedIndex = [];
  public filteredIndex = [];

  public filename: string;

  public content;
  public readmes: Models.Readme[];
  public selectedReadme = null;

  public isMarkdown = false;

  constructor(
    private ms: MessengerService,
    private openReadmeService: OpenReadmeService,
    private readmeService: ReadmeService
  ) {
    this.openReadmeService.$openEntry.subscribe(entry => {
      this.isMarkdown = false;
      this.selectedReadme = null;
      if (entry && entry.name) {
        const readme = _.find(this.readmes, doc => doc.name === entry.name && _.includes(doc.tags, entry.tag));
        if (!readme) {
          console.log('this readme could not be found: ', entry);
          return;
        }
        setTimeout(() => {
          this.isMarkdown = true;
          this.selectedReadme = readme.readme;
        }, 1);
      }
    });

    this.openReadmeService.$reload.subscribe(reload => {
      if (reload) {
        this.mappedIndex = [];
        this.ngOnInit();
      }
    });
  }

  ngOnInit() {
    this.readmeService.find(0, 100, {}).then(readmes => {
      if (!readmes || !readmes.data) {
        return;
      }
      this.readmes = readmes.data;
      this.initTags();
      this.ms.$activePrivileges.subscribe(value => {
        this.filterByPrivileges(value);
      });
    })
  }

  initTags() {
    const indexFile = require('../../../assets/readme/index.json');
    const tags = indexFile.tags;

    _.forEach(tags, (tag) => {
      const readmes = _.filter(this.readmes, (readme) => _.includes(readme['tags'], tag['value']));
      _.sortBy(readmes, 'title');
      this.mappedIndex.push({ tag: tag['value'], tagTitle: tag['name']['de'], privileges: tag['privileges'], entries: readmes })
    });
    _.sortBy(this.mappedIndex, 'tag');
  }

  filterByPrivileges(privileges) {
    this.filteredIndex = [];
    if (!privileges) {
      this.filteredIndex = _.filter(this.mappedIndex, (entry) => {
        if (!entry.privileges || JSON.stringify(entry.privileges) === '{}') {
          return true;
        }
      });
      return;
    }
    this.filteredIndex = _.filter(this.mappedIndex, (entry) => {
      if (!entry.privileges || JSON.stringify(entry.privileges) === '{}') {
        return true;
      }
      let include = false;
      for (const privilege of privileges) {
        const data = entry.privileges;
        if (privilege.privilegeName === data.name && privilege.value === data.value) {
          include = true;
        }
      }
      return include;
    });
  }

  loadReadme(content) {
    this.isMarkdown = true;
    this.selectedReadme = content;
  }

  goBack(): void {
    this.isMarkdown = false;
    this.selectedReadme = null
  }

}
